<div class="list-questions__container">
  <div class="list-questions__header">
    <div class="list-questions__header-title">
      <span class="fs__lg fw__500">Hidden questions</span>
      @if (count$() > 0) {
        <span class="counter fs__sm fw__500">{{ count$() }} items</span>
      }
    </div>
  </div>

  <div class="list-questions__list">
    <mat-action-list>
      @for (question of questionsHidden$ | async; track question.id; let index = $index) {
        <empathy-list-question-item-wrapper
          [activeQuestionId]="activeHiddenQuestionId$()"
          [question]="question"
          (activate)="onActivate($event)"
          (filterComments)="filterComments.emit($event)"
        />
      }
    </mat-action-list>
  </div>
</div>
